// extracted by mini-css-extract-plugin
export default {"input":"AddUser_input__i2EJi"};